import React, { Component } from "react";
import { Row, Col, Input, Divider, Button, Empty } from "antd";
import { AiOutlineSearch, AiOutlinePlus, FiPlusCircle } from "react-icons/all";
import { GrClose } from "react-icons/gr";
import "./style.css";
import EmployeCard from "../../components/EmployeCard";
import CustomModal from "../../components/modals/customModal";
import TextInput from "../../components/input/TextInput";
import { connect } from "react-redux";
import { UserAction } from "../../store/actions";
import { formatToNumber } from "../../config/utils";
import { EMAIL_REGX, PHONE_REGX } from "../../config/variables";
import LoaderGif from "../../assets/images/ie_loader.gif";
import { BsChevronLeft } from "react-icons/bs";
import { BsChevronRight } from "react-icons/bs";
class EmployeContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isClose: false,
      isOpenModal: false,
      editItem: false,
      edituserImage: "",
      filter: {
        order: "asc",
        page: 1,
        column: "email",
        search: "",
        per_page: 12,
      },
      payload: {
        title: "",
        first_name: "",
        last_name: "",
        phone: "",
        password: "",
        confirm_password: "",
        address: "",
        email: "",
        image: "",
      },
      errors: {
        first_nameError: "",
        last_nameError: "",
        phoneError: "",
        passwordError: "",
        confirm_passwordError: "",
        emailError: "",
      },
      isUpdate: false,
      userId: "",
      coverImageUrl: "",
    };
  }
  componentDidMount() {
    const { getUser } = this.props;
    const companyId = JSON.parse(localStorage.getItem("logistics_Auth"))?.[1]
      ?.logistics_partner?.id;

    getUser(companyId, this.state.filter);
  }
  componentDidUpdate(preProps, preState) {
    const { getUser } = this.props;
    const companyId = JSON.parse(localStorage.getItem("logistics_Auth"))[1]
      ?.logistics_partner?.id;
    if (preProps.metaData !== this.props.metaData) {
      this.setState({
        filter: {
          ...this.state.filter,
          page: this.props?.metaData?.current_page,
          total_records: this.props?.metaData?.total_records,
          current_records: this.props?.metaData?.current_records,
          total_pages: this.props?.metaData?.total_pages,
        },
      });
    }

    if (
      preState.filter.search !== this.state.filter.search ||
      preState.filter.column !== this.state.filter.column ||
      preState.filter.per_page !== this.state.filter.per_page ||
      preState.filter.page !== this.state.filter.page
    ) {
      getUser(companyId, this.state.filter);
    }
  }

  toggleModal = () => {
    this.setState({
      isOpenModal: !this.state.isOpenModal,
      isUpdate: false,
      payload: {
        title: "",
        first_name: "",
        last_name: "",
        phone: "",
        password: "",
        confirm_password: "",
        address: "",
        email: "",
        image: "",
      },
      errors: {
        first_nameError: "",
        last_nameError: "",
        phoneError: "",
        passwordError: "",
        confirm_passwordError: "",
        emailError: "",
      },
      edituserImage: "",
      image: "",
      editItem: false,
    });
  };
  onHandleChanged = (e) => {
    this.setState({
      payload: { ...this.state.payload, [e.target.name]: e.target.value },
      errors: { ...this.state.errors, [`${e.target.name}Error`]: "" },
    });
  };

  currentPage = (e) => {
    this.setState({
      filter: {
        ...this.state.filter,
        page: this.state.filter?.page + 1,
      },
    });
  };
  previousPage = (e) => {
    this.setState({
      filter: {
        ...this.state.filter,
        page: this.state.filter?.page - 1,
      },
    });
  };
  onSubmit = () => {
    let fNameError = "";
    let lNameError = "";
    let PNError = "";
    let CPError = "";
    let PError = "";
    let EError = "";
    const {
      payload: {
        first_name,
        last_name,
        phone,
        confirm_password,
        password,
        email,
      },
      isUpdate,
      userId,
    } = this.state;

    if (
      !first_name?.trim()?.length ||
      !last_name?.trim()?.length ||
      !PHONE_REGX.test(formatToNumber(phone)) ||
      !EMAIL_REGX.test(email) ||
      (!isUpdate && !password?.trim().length) ||
      (!isUpdate && !!password?.trim().length && password?.length < 8) ||
      (!isUpdate && password?.trim()?.length && confirm_password !== password)
    ) {
      if (!first_name?.trim()?.length) {
        this.state.errors.first_nameError = "First name is required";
      }
      if (!last_name?.trim()?.length) {
        this.state.errors.last_nameError = "Last name is required";
      }
      if (!PHONE_REGX.test(formatToNumber(phone))) {
        this.state.errors.phoneError = "Phone number is required";
      }
      if (!EMAIL_REGX.test(email)) {
        this.state.errors.emailError = "Email is required";
      }

      if (!isUpdate && !password?.trim().length) {
        this.state.errors.passwordError = "Password is required";
      }
      if (!isUpdate && !!password?.trim().length && password?.length < 8) {
        this.state.errors.passwordError =
          "Password should be at least 8 characters long";
      }
      if (!isUpdate && password?.length >= 8 && confirm_password !== password) {
        this.state.errors.confirm_passwordError = "password mismatch";
      }
      this.setState({
        errors: this.state.errors,
      });
      return;
    }
    //
    !isUpdate &&
      this.props.createUser(
        this.state.payload,
        () => this.setState({ isOpenModal: false }),
        this.state.filter
      );
    isUpdate &&
      this.props.updateUser(
        this.state.payload,
        () => this.setState({ isOpenModal: false, isUpdate: false }),
        userId
      );
  };

  render() {
    const {
      isOpenModal,
      filter: { per_page, column, page, order, search },
      payload: {
        first_name,
        last_name,
        address,
        phone,
        confirm_password,
        password,
        title,
        email,
      },
      errors: {
        first_nameError,
        last_nameError,
        passwordError,
        confirm_passwordError,
        emailError,
        phoneError,
      },
      isUpdate,
    } = this.state;
    var inputFileRef;
    const { users, isLoading, metaData } = this.props;
    return (
      <Row justify="center" style={{ marginTop: "15px" }}>
        <Col
          xl={24}
          lg={24}
          xs={24}
          sm={24}
          md={24}
          style={{
            minHeight: "calc(100vh - 4.8em)",
            width: "100%",
            padding: "1rem",
            background: "white",
            width: "100%",
            marginTop: "0.4rem",
          }}
        >
          <Row
            justify="space-between"
            style={{ borderBottom: "1px solid #babbc0", height: "38px" }}
          >
            <Col xl={24} lg={24} xs={24} sm={24} md={24}>
              <Row justify="space-between">
                <Col xl={12} lg={12} xs={24} sm={24} md={12}>
                  <h5 className="text-left"> All Employees</h5>
                </Col>
                <Col>
                  <AiOutlineSearch
                    size="20"
                    onClick={() =>
                      this.setState({ isClose: !this.state.isClose })
                    }
                    className="pointer-cursor"
                  />

                  <Input
                    placeholder="Search..."
                    style={{
                      width: this.state.isClose ? "130px" : "0px",
                      padding: 5,
                      // marginTop: '10px',
                      background: "transparent",
                      border: "none",
                      borderBottom: "none",
                      marginRight: "5px",
                    }}
                    onChange={(e) =>
                      this.setState({
                        filter: {
                          ...this.state.filter,
                          search: e.target.value,
                        },
                      })
                    }
                    value={search}
                  />
                  {this.state.isClose && (
                    <GrClose
                      size="20"
                      onClick={() =>
                        this.setState({
                          filter: {
                            ...this.state.filter,
                            search: "",
                          },
                          isClose: !this.state.isClose,
                        })
                      }
                      style={{ marginRight: "20px" }}
                      className="pointer-cursor"
                    />
                  )}

                  <span onClick={this.toggleModal} className="pointer-cursor">
                    <AiOutlinePlus size="20" />
                  </span>
                </Col>
              </Row>
            </Col>
          </Row>
          <Row style={{ marginTop: "2rem" }} justify="space-between">
            <Col xl={7} lg={6} md={14} sm={24} xs={24}>
              <Row justify="space-between" className="text-left">
                <Col xl={12} sm={12} md={14} lg={12} className="text-left">
                  <label
                    style={{
                      fontSize: "0.8rem",
                    }}
                  >
                    Sort By
                  </label>
                  <select
                    className="pointer-cursor"
                    style={{ padding: "5px 10px 5px 10px", marginLeft: "5px" }}
                    onChange={(e) => {
                      this.setState({
                        filter: {
                          ...this.state.filter,
                          column: e.target.value,
                        },
                      });
                    }}
                    value={column}
                  >
                    <option value="email">Email</option>
                    <option value="first_name">Name</option>
                  </select>
                </Col>
                <Col xl={12} sm={12} md={10}>
                  <label
                    style={{
                      fontSize: "0.8rem",
                    }}
                  >
                    Showing
                  </label>
                  <select
                    className="pointer-cursor"
                    style={{
                      padding: "5px 10px 5px 10px",
                      marginLeft: "5px",
                      width: "73px",
                    }}
                    onChange={(e) => {
                      this.setState({
                        filter: {
                          ...this.state.filter,
                          per_page: e.target.value,
                        },
                      });
                    }}
                    value={per_page}
                  >
                    <option>12</option>
                    <option>24</option>
                    <option>48</option>
                    <option>96</option>
                  </select>
                </Col>
              </Row>
            </Col>
          </Row>
          <Row justify="start">
            {!isLoading ? (
              <>
                {(users || []).map((item) => (
                  <Col xl={6} md={12} sm={24} xs={24} lg={8}>
                    <EmployeCard
                      item={item.user}
                      isUpdate={isUpdate}
                      onEdit={() => {
                        this.setState({
                          isOpenModal: true,
                          payload: item.user,
                          isUpdate: true,
                          userId: item.id,
                          editItem: true,
                          edituserImage: item?.user?.image?.original,
                        });
                      }}
                      updateUser={this.props.updateUser}
                      status={item.status === 2 ? "active" : "deactivate"}
                      userId={item.id}
                    />
                  </Col>
                ))}
                {!users?.length && (
                  <Col span={23}>
                    <Empty description="Nothing to show right now" />
                  </Col>
                )}
                {!!users?.length && (
                  <Col xs={24} sm={24} md={23} lg={24} xl={24}>
                    <Row
                      gutter={[5, 0]}
                      xs={24}
                      sm={24}
                      md={23}
                      lg={23}
                      xl={23}
                      justify="end"
                    >
                      <Col className="tablePagination">
                        {console.log('pagination metadata===>', metaData)}
                        {/* {`Displaying ${metaData?.current_records} of ${metaData?.total_records}`} */}
                        {`Displaying ${metaData?.current_page !== metaData.total_pages
                          ? metaData?.current_records * metaData?.current_page
                          : metaData?.total_records
                          } of ${metaData?.total_records}`}
                        <Button
                          type="link"
                          icon={<BsChevronLeft color="#686868" size={15} />}
                          onClick={this.previousPage}
                          disabled={this.state.filter.page === 1}
                        />
                        <Button
                          type="link"
                          icon={<BsChevronRight color="#686868" size={15} />}
                          onClick={this.currentPage}
                          disabled={
                            this.state.filter.total_pages === this.state.filter.page
                          }
                        />
                      </Col>
                    </Row>
                  </Col>
                )}
              </>
            ) : (
              <>
                <Col span={23}>
                  {isLoading && (
                    <img src={LoaderGif} height={"60"} width={"60"} />
                  )}
                </Col>
              </>
            )}
            <CustomModal
              visible={isOpenModal}
              onCancelModal={this.toggleModal}
              footer={[
                <Button
                  style={{
                    backgroundColor: "#ff9800",
                    color: "#fff",
                    width: "30%",
                    border: "none",
                  }}
                  onClick={this.onSubmit}
                >
                  Save
                </Button>,
              ]}
            >
              <Col xl={24}>
                {this.state.editItem === true ? (
                  <h5 className="text-center st-primary">Edit Member</h5>
                ) : (
                  <h5 className="text-center st-primary">Add Member</h5>
                )}
                <Divider />
              </Col>
              <Col xl={24} className="pointer-cursor">
                <Row justify="center" className="modal-internal-scroll">
                  <Col
                    xl={7}
                    className="text-center"
                    onClick={() => {
                      inputFileRef.click();
                      this.setState({
                        image: "",
                      });
                    }}
                  >
                    {this.state.edituserImage ? (
                      <img
                        src={this.state.edituserImage}
                        width="100px"
                        height="100px"
                        style={{ borderRadius: "100%" }}
                      />
                    ) : (
                      <FiPlusCircle
                        size="90"
                        color="#009688"
                        className="text-center pointer-cursor"
                      />
                    )}

                    {this.state.editItem === true ? (
                      <label
                        style={{
                          fontSize: "0.8rem",
                          color: "#9e9e9e",
                          textAlign: "center",
                        }}
                      >
                        CHANGE IMAGE
                      </label>
                    ) : (
                      <span></span>
                    )}
                  </Col>
                  <Col xl={24}>
                    <form>
                      <Row justify="space-between" gutter={[5, 30]}>
                        <Col xl={24}>
                          <TextInput
                            label="Title"
                            name="title"
                            onChange={this.onHandleChanged}
                            value={title}
                          />
                        </Col>
                        <Col xl={10}>
                          <TextInput
                            label="First Name"
                            name="first_name"
                            required
                            onChange={this.onHandleChanged}
                            value={first_name}
                            isError={first_nameError}
                          />
                          <span className="danger-color">
                            {first_nameError && first_nameError}
                          </span>
                        </Col>
                        <Col xl={10}>
                          <TextInput
                            label="Last Name"
                            name="last_name"
                            required
                            onChange={this.onHandleChanged}
                            value={last_name}
                          />
                          <span className="danger-color">
                            {last_nameError && last_nameError}
                          </span>
                        </Col>
                        <Col xl={10}>
                          <TextInput
                            label="Phone Number"
                            name="phone"
                            required
                            type="text"
                            onChange={this.onHandleChanged}
                            // isError={}

                            maxLength={15}
                            value={formatToNumber(phone || "")}
                          />
                          <span className="danger-color">
                            {phoneError && phoneError}
                          </span>
                        </Col>
                        <Col xl={10}>
                          <TextInput
                            label="Email Address"
                            required
                            name="email"
                            onChange={this.onHandleChanged}
                            value={email}
                          />
                          <span className="danger-color">
                            {emailError && emailError}
                          </span>
                        </Col>
                        {!isUpdate && (
                          <>
                            <Col xl={10}>
                              <TextInput
                                name="password"
                                label="Password"
                                required
                                onChange={this.onHandleChanged}
                                type="password"
                                value={password}
                              />
                              <span className="danger-color">
                                {passwordError && passwordError}
                              </span>
                            </Col>
                            <Col xl={10}>
                              <TextInput
                                label="Confirm Password"
                                name="confirm_password"
                                required
                                type="password"
                                value={confirm_password}
                                onChange={this.onHandleChanged}
                              />
                              <span className="danger-color">
                                {confirm_passwordError && confirm_passwordError}
                              </span>
                            </Col>
                          </>
                        )}

                        <Col xl={24}>
                          <TextInput
                            name="address"
                            label="Address"
                            onChange={this.onHandleChanged}
                            value={address}
                          />
                        </Col>
                      </Row>
                      <input
                        type="file"
                        id="avatar"
                        name="avatar"
                        accept="image/png, image/jpeg"
                        className="d-none"
                        ref={(ref) => (inputFileRef = ref)}
                        onChange={(e) => {
                          let reader = new FileReader();
                          let file = e.target.files[0];
                          reader.readAsDataURL(file);

                          reader.onloadend = () => {
                            console.log("reader==>", reader.result);
                            this.setState({
                              // payload: {
                              //   ...this.state.payload,
                              //   image: e.target.files[0],
                              // },
                              edituserImage: reader.result,
                              payload: {
                                ...this.state.payload,
                                image: e.target.files[0],
                              },
                            });
                          };
                        }}
                      />
                    </form>
                  </Col>
                </Row>
              </Col>
            </CustomModal>
          </Row>
        </Col>
      </Row>
    );
  }
}
function mapStateToProps(store) {
  return {
    users: store.UserReducer.users,
    isLoading: store.UserReducer.isLoading,
    metaData: store.UserReducer.metaData,
  };
}
function mapDispatchToProps(dispatch) {
  return {
    getUser: (id, params) => dispatch(UserAction.getUserReq(id, params)),
    createUser: (payload, cb, params) =>
      dispatch(UserAction.createUserReq(payload, cb, params)),
    updateUser: (body, cb, id, active) =>
      dispatch(UserAction.updateProfileInfoReq(body, cb, id, active)),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(EmployeContainer);
